<template lang="pug">
  div.text.row
    el-col(:span="9")
      slot
    el-col(:span="15")
      el-radio-group(v-model="radio", @change="changeRadio")
        el-radio(label="no") ไม่มี
        el-radio(label="yes") มี
          el-row
            el-checkbox-group(v-show="radio === 'yes'" v-model="checkbox" @change="setValue($event)").group-vertical.checkbox
              el-checkbox(label="dog") หมา
              el-checkbox(label="cat") แมว
</template>

<style lang="scss" scoped>
.row {
  display: flex;
  justify-content: space-between;
  margin-top: 5px;
}
.text {
  color: #606266;
  font-size: 18px;
  font-weight: 400;
  line-height: 2.2;
}
.radio {
  margin-top: 12px;
  margin-left: 0px;
  font-size: 16px;
}

.el-radio-group {
  display: flex;
  justify-content: flex-start;
}

.el-checkbox-group {
  display: flex;
  align-items: flex-start;
}

.el-checkbox+.el-checkbox {
  margin-left: 0px;
  margin-top: 8px;
}

.group-vertical {
    display: flex;
    flex-direction: column;
    align-items: baseline;
    &.checkbox {
      margin-top: 12px;
      margin-left: 16px;
      font-size: 16px;
    }
  }

</style>

<script>
export default {
  name: 'radioYesNoCheckbox',
  props: ['petValid', 'checkboxValue'],
  data () {
    return {
      checkbox: [],
      radio: '',
    }
  },
  watch: {
    petValid (newVal, oldVal) {
      this.petValid = newVal
      this.checkRadio()
    },
    checkboxValue (newVal, oldVal) {
      let checkboxValue = []
      if (this.checkboxValue) {
        if (this.checkboxValue.dog) checkboxValue.push('dog')
        if (this.checkboxValue.cat) checkboxValue.push('cat')
      }
      this.checkbox = checkboxValue
    },
  },
  methods: {
    makePetObject () {
      return {
        'dog': false,
        'cat': false,
      }
    },
    checkRadio () {
      if ((this.petValid === undefined || this.petValid) && !this.checkboxValue) {
        this.radio = 'no'
      } else if ((this.petValid === undefined || this.petValid) && (typeof this.checkboxValue === 'object' && Object.keys(this.checkboxValue).length > 0)) {
        this.radio = 'yes'
      }
    },
    changeRadio (value) {
      this.radio = value
      this.$emit('update:petValid', true)
      if (value === 'no') {
        this.$emit('update:checkboxValue', null)
      } else {
        this.$emit('update:checkboxValue', this.makePetObject())
      }
    },
    setValue (event) {
      let checkboxValue = this.makePetObject()
      for (let i = 0; i < event.length; i++) {
        if (event[i] === 'dog') checkboxValue.dog = true
        if (event[i] === 'cat') checkboxValue.cat = true
      }
      this.$emit('update:checkboxValue', checkboxValue)
    },
  },
}
</script>
